<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" needsLogin fullscreen persistent width="720" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet class="scroll-primary pr-10" style="flex: 0 1 auto; overflow-y: auto; overflow-x: hidden">
                <vertical-form-table v-model="form" v-bind="{ items }">
                    <template #프로그램> {{ program.subject }} </template>
                </vertical-form-table>
            </v-sheet>
            <div class="v-btn-group">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="shows = false">
                    <span class="grey-6--text"> 취소 </span>
                </v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="save">
                    <span> {{ execText }} </span>
                </v-btn>
            </div>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables/attrs";
import { initExpoProgram, initExpoInquiry } from "@/assets/variables/inits";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        term: "프로그램",
    },
    {
        key: "subject",
        term: "제목",
        type: "text",
    },
    {
        key: "content",
        term: "내용",
        type: "textarea",
    },
    {
        key: "isSecret",
        term: "비밀글",
        type: "switch",
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        BottomSheet,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initExpoInquiry },
        program: { type: Object, default: initExpoProgram },
    },
    data: () => ({
        form: initExpoInquiry(),

        shows: false,
        loading: false,

        items,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
        _program() {
            return this.program._id;
        },
        title() {
            let title = "문의하기";

            if (this.isCreate) title += " 생성";
            else title += " 수정";

            return title;
        },
        execText() {
            if (this.isCreate) return "생성하기";
            else return "수정하기";
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
            else if (this.form?._id) this.$emit("input", this.form);
        },
    },
    methods: {
        async init() {
            this.loading = false;
            if (this.isCreate) {
                this.form = initExpoInquiry();
            } else {
                this.loading = true;
                try {
                    let { inquiry } = await api.v1.expo.programs.inquiries.get({
                        _id: this.value._id,
                        _program: this._program,
                    });
                    this.form = initExpoInquiry(inquiry);
                } finally {
                    this.loading = false;
                }
            }
        },

        validate() {
            try {
                if (!this.form.subject) {
                    throw new Error("제목을 입력해주세요");
                }

                if (!this.form.content) {
                    throw new Error("제목을 입력해주세요");
                }

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },

        async save() {
            if (!this.validate()) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { ...form } = this.form;
                form._program = this._program;

                const { post, put } = api.v1.expo.programs.inquiries;
                let { inquiry } = await (this.isCreate ? post : put)(form);

                this.form = initExpoInquiry(inquiry);
                this.$emit("input", this.form);
                this.shows = false;
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        async emit() {
            this.form = initExpoInquiry(this.form);
        },
    },
};
</script>
